//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import explainDetaulModal from "./explainDetaulModal.vue";
export default {
  name: 'ExplainModal',
  mixins: [JeecgListMixin],
  components: {
    explainDetaulModal: explainDetaulModal
  },
  data: function data() {
    return {
      siteList: [],
      title: '选择巡检说明',
      queryParam: {},
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '标题',
        align: 'center',
        dataIndex: 'title'
      }, {
        title: '类别',
        align: 'center',
        dataIndex: 'categoryName'
      }, {
        title: '关键字',
        align: 'center',
        dataIndex: 'keyword'
      }, {
        title: '排序号',
        align: 'center',
        dataIndex: 'sort'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      dataSource: [],
      companyList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      category: '',
      url: {
        list: '/sys/doc/list',
        delete: '/sys/doc/delete',
        deleteBatch: '/sys/doc/deleteBatch',
        exportXlsUrl: '/sys/doc/exportXls',
        importExcelUrl: '/sys/doc/importExcel'
      }
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      getAction(this.url.list + '?category=' + this.category, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    // getQueryParams() {
    //     let param = Object.assign({}, this.queryParam, this.isorter)
    //     param.field = this.getQueryField()
    //     param.pageNo = this.ipagination.current
    //     param.pageSize = this.ipagination.pageSize
    //     return filterObj(param)
    // },
    // getQueryField() {
    //     let str = 'id,'
    //     for (let a = 0; a < this.columns.length; a++) {
    //         str += ',' + this.columns[a].dataIndex
    //     }
    //     return str
    // },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    handleOk: function handleOk() {
      if (this.selectionRows.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }

      this.$emit('selectProduct', this.selectionRows);
      this.handleCancel();
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    checkExplain: function checkExplain(record) {
      this.$refs.explainDetaulModal.visible = true;
      this.$refs.explainDetaulModal.add(record);
    }
  }
};